import { clone, startCase } from 'lodash';

import actionClassMapping from './ActionClassMapping.json';
import actionStatementMapping from './ActionStatementMapping';

export function getActionViewData(log) {
  return clone(actionClassMapping[log.action]);
}

/** Returns the statement as parts, `{ text, isStrong }`, where every `text` is plain text. */
export function getActionStatement(log) {
  const mapping =  actionStatementMapping[log.typeName]?.[log.userAction];

  if (mapping?.statement) {
    const statement = mapping.statement;

    const isLinkedWithSecondaryObject = mapping.linkedWithAnotherItem;

    if (isLinkedWithSecondaryObject) {
      try {
        const diffKey = Object.keys(log.diff)[0];

        const secondaryObjectName = mapping?.secondaryObjectMappingWithDiffProperty?.[diffKey];

        if (secondaryObjectName) {
          return toParts(statement, { userName: log.userName, objectName: log.objectName, secondaryObjectName });
        } else {
          return getDefaultStatement(log);
        }
      } catch {
        return getDefaultStatement(log);
      }
    }

    return toParts(statement, { userName: log.userName, objectName: log.objectName });
  }

  return getDefaultStatement(log);
}

export function getDefaultStatement(log) {
  const viewData = getActionViewData(log);
  return [
    { text: (log.userName || '') + ' ' + viewData.actionText + ' ' + startCase(log.typeName) + ' ' },
    { text: log.objectName || log.objectId, isStrong: true }
  ];
}

/** Only `<strong>` is markup in a statement template; `[{name}]` placeholders take their value from `values`. */
function toParts(template, values) {
  return template
    .split(/<\/?strong>/)
    .map((text, index) => ({
      text: text.replace(/\[\{(\w+)\}\]/g, (_, name) => values[name]),
      isStrong: index % 2 === 1
    }))
    .filter(part => part.text !== '');
}
